import FormPrint from './FormPrint';

export default FormPrint;
